import WarningIcon from '@mui/icons-material/Warning';
import { useSelector } from 'react-redux';

import { JobStatus, Permission } from '../../../../enums';
import type { Job } from '../../../../models';
import { fuelUserAccessSliceSelector } from '../../../../store/slices/fuelUserAccess';
import clientUtils from '../../../../utils/clientUtils';

export type ResubmitStatus = 'unavailable' | 'available' | 'submitted' | 'error';

const IntakeStepsTable = ({ jobs, onResubmitJob, resubmitStatuses }: any) => {
  const { permissions } = useSelector(fuelUserAccessSliceSelector);

  const calcStatusClass = (job: Job): string => {
    switch (job.status) {
      case JobStatus.Unknown:
      case JobStatus.Started:
        return 'status-cell';
      case JobStatus.Completed:
        return 'status-cell good';
      case JobStatus.Failed:
      case JobStatus.Invalid:
        return 'status-cell bad';
    }
  };

  const isBadStatus = (job: Job): boolean => {
    switch (job.status) {
      case JobStatus.Unknown:
      case JobStatus.Started:
      case JobStatus.Completed:
        return false;
      case JobStatus.Failed:
      case JobStatus.Invalid:
        return true;
    }
  };

  const getResubmitStatus = (job: Job): ResubmitStatus => {
    if (!permissions.has(Permission.IngestRetry)) return 'unavailable';

    const value = resubmitStatuses[job.jobId];
    if (value !== undefined) {
      return value as ResubmitStatus;
    }
    switch (job.status) {
      case JobStatus.Started:
      case JobStatus.Completed:
        return 'unavailable';
      case JobStatus.Unknown:
      case JobStatus.Failed:
      case JobStatus.Invalid:
        return 'available';
    }
  };

  return (
    <div className="intake-steps-table" test-id="intake-steps-table">
      {/* <div className="header-row">
        <div>Step</div>
        <div>Step Status</div>
        <div>Last Updated</div>
        <div>Resubmit</div>
      </div> */}
      <div>
        <table className="scroll-table">
          <thead>
            <tr>
              <th>Step</th>
              <th>Step Status</th>
              <th>Last Updated</th>
              <th>Resubmit</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job, key) => {
              return (
                <tr key={job.jobId}>
                  <td className="job-type-cell">{job.jobType}</td>
                  <td className={calcStatusClass(job)}>
                    {job.status} {isBadStatus(job) && <WarningIcon className="warning-icon" />}
                  </td>
                  <td className="last-updated-cell">{clientUtils.formatUTCDateTime(job.lastUpdated)}</td>
                  <td className="actions-cell">
                    {getResubmitStatus(job) === 'available' && (
                      <span>
                        {' '}
                        <i
                          test-id="refresh-icon"
                          aria-hidden="true"
                          className="icon material-icons"
                          onClick={(evt) => onResubmitJob(job)}
                        >
                          refresh
                        </i>
                      </span>
                    )}
                    {getResubmitStatus(job) === 'submitted' && <span className="was-submitted">Submitted</span>}
                    {getResubmitStatus(job) === 'error' && <span className="was-error">Error</span>}
                    {getResubmitStatus(job) === 'unavailable' && <span>N/A</span>}
                  </td>
                </tr>
              );
            })}
            <tr />
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IntakeStepsTable;
